<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5wjSKU/tc-custom/9781328628657.jpg?1731883518592" alt="This image is the cover for the book In At The Deep End"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In At The Deep End
      </h1>
      <p class="bookDescription body article font2">
        <b>* A Finalist for the Bollinger Everyman Wodehouse Prize for Comic Fiction * One of <i>Autostraddle</i>'s Best Queer Books of 2019 * </b><br/><br/><b>A deliciously disarming debut novel about a twenty-something Londoner who discovers that she may have been looking for love—and pleasure—in all the wrong places (i.e., from men).</b><br/><br/> Julia has had enough. Enough of the sex noises her roommate makes. Enough of her dead-end government job. Enough of the one-night stand who accused her of breaking his penis. The only thing she hasn’t had enough of is orgasms; she hasn’t had proper sex in three years.<br/><br/> So when Julia gets invited to a warehouse party in a part of town where trendy people who have lots of sex go on a Friday night, she readily accepts. And that night she meets someone: a figurative artist who also happens to be a woman.<br/><br/> Julia’s sexual awakening begins; her new lesbian life is exhilarating. She finds her tribe at queer swing-dancing classes, and guided by her new lover Sam, she soon discovers London’s gay bars and BDSM clubs—and the complexities of polyamory. Soon it becomes clear that Sam needs to call the shots, and Julia’s newfound liberation comes to bear a suspicious resemblance to entrapment . . . <br/><br/><i>In at the Deep End</i> is an unforgettable and audacious odyssey through the pitfalls and seductions we encounter on the treacherous path to love and self. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate Davies
      </h2>
      
      <p class="authorDescription body article">KATE DAVIES was born and brought up in north-west London. She studied English at Oxford University before becoming a writer and editor of children&rsquo;s books. She also writes comedy scripts, and had a short-lived career as a burlesque dancer that ended when she was booed off stage at a Conservative club, dressed as a bingo ball. Kate lives in east London with her wife. <I>In at the Deep End</I> is her debut novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1acec716